<template>
  <div>
    <vx-card>
      <vs-table pagination :max-items="10" search :data="_prosecutions">
        <template slot="thead">
          <vs-th sort-key="caseNumber">{{ $t('sections.prosecution.dataForm.caseNumber') }}</vs-th>
          <vs-th sort-key="lawyerAcceptedDate">{{ $t('sections.prosecution.dataForm.lawyerAcceptedDate') }}</vs-th>
          <vs-th sort-key="prosecutionType">{{ $t('sections.prosecution.dataForm.prosecutionType') }}</vs-th>
          <vs-th sort-key="contractName">{{ $t('sections.prosecution.dataForm.contractName') }}</vs-th>
          <vs-th sort-key="contractNo">{{ $t('sections.prosecution.dataForm.contractNo') }}</vs-th>
          <vs-th sort-key="total">{{ $t('sections.prosecution.dataForm.totalAsset') }}</vs-th>
          <vs-th sort-key="caseStatus">สถานะ</vs-th>
          <vs-th sort-key="" class="w-1/12"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="row" :key="index" v-for="(row, index) in data">
            <vs-td :data="row.caseNumber">
              {{ row.caseNumber }}
            </vs-td>
            <vs-td :data="row.lawyerAcceptedDate">
              {{ row.lawyerAcceptedDate | convYYYYMMDDToDDMMYYYY }}
            </vs-td>
            <vs-td :data="row.prosecutionTypeName">
              {{ row.prosecutionTypeName }}
            </vs-td>
            <vs-td :data="row.contractName">
              {{ row.contractName }}
            </vs-td>
            <vs-td :data="row.contractNo">
              {{ row.contractNo }}
            </vs-td>
            <vs-td :data="row.total">
              {{ row.total | numberFormat }}
            </vs-td>
            <vs-td :data="row.caseStatusName">
              <vs-chip :color="row.caseStatus | caseStatusColor" class="product-order-status">{{ row.caseStatusName  }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                <vx-tooltip text="ดูข้อมูลการดำเนินคดี">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-menu" @click="transaction(row)"  v-if="visibilityView(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ฝ่ายกฎหมายรับงาน">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-check-square" @click="lawyerAccept(row.id)"  v-if="visibilityLawyerAccept(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ฝ่ายกฎหมายแก้ไขข้อมูล">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" @click="lawyerEdit(row.id)"  v-if="visibilityLawyerEdit(row)"></vs-button>
                </vx-tooltip>
                <vx-tooltip text="ฝ่ายกฎหมายตีกลับข้อมูล">
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-x-circle" @click="onPressedActiveLawyerRejectModal(row)"  v-if="visibilityLawyerReject(row)"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vs-popup
      :active.sync="rejectModal.active"
      title="ฝ่ายกฎหมายตีกลับข้อมูล"
      class="custom-popup"
    >
      <div class="popup-content">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <p>เลขที่: {{  rejectModal.caseNumber }}</p>
          </div>
          <div class="vx-col w-1/2">
            <p>ชื่อสัญญา: {{  rejectModal.contractName }}</p>
          </div>
        </div>
        <div class="vx-row mt-1">
          <div class="vx-col w-full">
            <vs-textarea type="text" class="w-full" v-model="rejectModal.remark"  rows="5"/>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedLawyerReject" class="mr-1">บันทึก</vs-button>
        <vs-button color="danger" @click="onPressedUnActiveLawyerRejectModal">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import {ICaseStatus} from "@/constants/interface";
const {mapActions: mapProsecutionActions, mapState: mapProsecutionState } = createNamespacedHelpers('Prosecution')

export default {
  async created () {
    const vm = this
    await vm.reloadComponent(vm.$route.params);
  },
  data() {
    return {
      rejectModal: {
        active: false,
        id: null,
        contractName: "",
        caseNumber: "",
        remark: "",
      },
    };
  },
  computed: {
    ...mapProsecutionState(['prosecutions', 'status']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    isLawyer(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'lawyer'
    },
    isLegalCounsel(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'legalCounsel'
    },
    isUser(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === ('normal' || 'super')
    },
    _prosecutions(){
      const vm = this;
      return vm.prosecutions
        .map(prosecution => {
        return {
          ...prosecution,
          lawyerAcceptedDate: prosecution.lawyerAcceptedDate,
          caseStatusName: prosecution.caseStatusName,
          createdAt: prosecution.createdAt,
        }
      }).sort((a, b) => {
          // Prioritize drafts at the front
          if (a.caseStatus === ICaseStatus.sendInformationContractToLawyer && b.caseStatus !== ICaseStatus.sendInformationContractToLawyer) {
            return -1; // a comes before b
          } else if (a.caseStatus !== ICaseStatus.sendInformationContractToLawyer && b.caseStatus === ICaseStatus.sendInformationContractToLawyer) {
            return 1; // b comes before a
          }
          // If both have the same caseStatus or neither is a draft, sort by createdAt
          return new Date(b.createdAt) - new Date(a.createdAt);
      })
    }
  },
  methods: {
    ...mapProsecutionActions(['getProsecutionsLawyerJob', 'updateProsecutionCaseStatus']),
    transaction(row){
      const {contract, id: prosecutionId} = row
      const { id: contractId} = contract
      this.$router.push({name: 'prosecution-transaction-detail', params: {contractId, prosecutionId}})
    },
    lawyerAccept(id){
      const vm = this
      const { updateProsecutionCaseStatus } = vm
      const { dialog } = vm.$vs
      dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการรับงาน',
        text: 'คุณต้องการรับงานใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await updateProsecutionCaseStatus({
            vm,
            id: id,
            form: {
              caseStatus: ICaseStatus.lawyerAccepted,
              remark: ''
            },
          })
          await vm.reloadComponent(vm.$route.params);
        }
      })
    },
    lawyerEdit(id){
      this.$router.push({name: 'prosecution-lawyerJob-edit', params: {id}})
    },
    onPressedLawyerReject(){
      const vm = this;
      this.rejectModal.active = false;
      const { updateProsecutionCaseStatus } = vm;
      const { dialog } = vm.$vs;
      const {
        id,
        remark
      } = vm.rejectModal;
      dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการตีกลับข้อมูล',
        text: 'คุณต้องการตีกลับข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await updateProsecutionCaseStatus({
            vm,
            id: id,
            form: {
              caseStatus: ICaseStatus.draft,
              remark
            },
          })
          await vm.reloadComponent(vm.$route.params);
        }
      })
    },
    async onPressedActiveLawyerRejectModal({id, contractName, caseNumber}) {
      this.rejectModal = {
        active: true,
        id,
        contractName,
        caseNumber,
        remark: "",
      }
    },
    async onPressedUnActiveLawyerRejectModal() {
      this.rejectModal = {
        active: false,
        id: null,
        contractName: "",
        caseNumber: "",
        remark: "",
      }
    },
    visibilityView(row){
      return row;
    },
    visibilityLawyerAccept({caseStatus, lawyerEmail}){
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      return caseStatus === ICaseStatus.sendInformationContractToLawyer  && (this.isRoot || isLawyerAssign);
    },
    visibilityLawyerEdit({caseStatus, lawyerEmail}){
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const caseStatuses = [ICaseStatus.draft, ICaseStatus.sendInformationContractToLawyer, ICaseStatus.cancelCase, ICaseStatus.closeCase];
      return !caseStatuses.includes(caseStatus) && (this.isRoot || isLawyerAssign);
    },
    visibilityLawyerReject({caseStatus, lawyerEmail}){
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const caseStatuses = [ICaseStatus.draft, ICaseStatus.cancelCase, ICaseStatus.closeCase];
      return !caseStatuses.includes(caseStatus) && (this.isRoot || isLawyerAssign);
    },
    async reloadComponent({ action = null }) {
      await this.getProsecutionsLawyerJob({ action });
    }
  },
  watch: {
    status: {
      handler(res){
        if(res.processing !== null){
          if(res.processing){
            this.$vs.loading();
          }else{
            this.$vs.loading.close();
          }
        }
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    '$route.params': {
      handler(newParams = {}, oldParams = {}) { // ตั้งค่า default เป็น empty object
        if (newParams.action !== oldParams.action) {
          this.reloadComponent(newParams);
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
